<div class="row">
  <div class="col-md-12">
    <mat-card appearance="outlined" class="marB16">
      <div *ngIf="editactivity">
        <button mat-icon-button class="close-button" [mat-dialog-close]="true" name="suitabilitydialogbtn">
          <mat-icon class="close-icon" color="warn">close</mat-icon>
        </button>
      </div>
      <div class="d-flex justify-content-between" style="margin-left: 18px; margin-top: 18px">
        <div class="txt_left">
          <h4 class="h3Header GreyDarkest text-1line marB16">{{ checkSuitabilityDataObj.activityName }}</h4>
        </div>
        <div class="d-flex" style="margin-right: 18px">
          <span class="data-letters float-left marR6 listleft">{{ loginUserName || 'NA' | initials }}</span>
          <h5 class="marginicon40 h5Header GreyLight marT8 float-right marR16">{{ loginUserName }}</h5>
          <span class="float-right marT4">
            <span class="marginicon40 mainBodyTxt3 GreyLight blockInfo" *ngIf="timeModifiedOn; else elseTemplate">
              {{ timeModifiedOn | dateTransform }}
            </span>
            <ng-template class="mainBodyTxt3 GreyLight blockInfo" #elseTemplate> </ng-template>
          </span>
        </div>
      </div>
      <mat-card-content class="clearfix" *ngIf="isCollapsed" [ngClass]="{ readActivityDisable: data && data.readFlag }">
        <span *ngIf="!error && !error1 && checkSuitabilityDataObj.activityId == 600104 && !editactivity">
          <div *ngIf="instList.length > 0">
            <h5>Institute List</h5>
            <span *ngFor="let univ of instList; let instInd = index">
              <mat-accordion class="accordion">
                <mat-expansion-panel
                  [expanded]="expandedEvent === univ.nameAsPerRecord && instInd == selectedIndexInst"
                  (opened)="expandedEvent = univ.nameAsPerRecord; selectedIndexInst = instInd"
                >
                  <mat-expansion-panel-header class="customExpansionPanel">
                    <strong> {{ univ.nameAsPerRecord }} ({{ univ.educationType }})</strong>
                  </mat-expansion-panel-header>
                  <table mat-table [dataSource]="univ.dnhOutput" aria-describedby="dnhtable" style="margin-top: 1px">
                    <ng-container matColumnDef="radiobutton">
                      <th mat-header-cell *matHeaderCellDef id="radio"></th>
                      <td mat-cell *matCellDef="let element; let index = index">
                        <span>
                          <mat-radio-group aria-label="Select an option" id="sortByInst-{{ univ.nameAsPerRecord }}">
                            <mat-radio-button
                              [value]="univ.selectedElement"
                              (change)="
                                radiobuttonChange(element, false, univ.nameAsPerRecord, selectedIndexInst, 'institute')
                              "
                              [checked]="univ.selectedElement && univ.selectedElement == element"
                              [disabled]="univ.dnhFlag"
                            >
                            </mat-radio-button>
                          </mat-radio-group>
                        </span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="organization">
                      <th mat-header-cell *matHeaderCellDef id="organization">
                        <span *ngIf="checkSuitabilityDataObj.activityId == 600104">University</span>
                      </th>
                      <td mat-cell *matCellDef="let element; let index = index">
                        {{ element.organization }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="abbreviated">
                      <th mat-header-cell *matHeaderCellDef id="abbreviated">Abbreviated</th>
                      <td mat-cell *matCellDef="let element; let index = index">
                        {{ element.abbreviated }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="category">
                      <th mat-header-cell *matHeaderCellDef id="category">Category</th>
                      <td mat-cell *matCellDef="let element; let index = index">
                        {{ element.category }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="score">
                      <th mat-header-cell *matHeaderCellDef id="score">Match Score</th>
                      <td mat-cell *matCellDef="let element">{{ element.score | number: '1.0-2' }}%</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" style="height: 40px"></tr>
                  </table>
                  <br />
                  <div style="padding-left: 26px" *ngIf="univ && univ.dnhOutput.length > 0" class="d-flex justify-content-between align-items-center">
                    <mat-checkbox
                      [value]="univ.selectedElement"
                      (change)="
                        radiobuttonChange(
                          univ.nameAsPerRecord,
                          true,
                          univ.nameAsPerRecord,
                          selectedIndexInst,
                          'institute',
                          $event
                        )
                      "
                      [checked]="univ.selectedElement && univ.selectedElement == univ.nameAsPerRecord"
                      style="font-size: 15px"
                      [disabled]="univ.dnhFlag"
                      id="radioNonDNHInst{{ univ.nameAsPerRecord }}{{ instInd }}"
                    >
                      {{ univ.nameAsPerRecord }} is NOT a Suspect/Orange/DNH Institute
                    </mat-checkbox>
                    <mat-checkbox
                      [checked]="univ.sendToBgv"
                      (change)="toggleSendToBgv(univ, $event)"
                      style="font-size: 15px"
                      [disabled]="univ.nonDNHelement || !univ.selectedElement || univ.dnhFlag"
                      id="sendToBgvInst{{ univ.nameAsPerRecord }}{{ instInd }}"
                    >
                      Send to BGV for Suspect/Orange/DNH Review
                    </mat-checkbox>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </span>
          </div>
          <div *ngIf="univList.length > 0">
            <h5>University List</h5>
            <span *ngFor="let univ of univList; let univInd = index">
              <mat-accordion class="accordion">
                <mat-expansion-panel
                  [expanded]="expandedEvent === univ.nameAsPerRecord && univInd == selectedIndexUniv"
                  (opened)="expandedEvent = univ.nameAsPerRecord; selectedIndexUniv = univInd"
                >
                  <mat-expansion-panel-header class="customExpansionPanel">
                    <strong> {{ univ.nameAsPerRecord }}</strong>
                    <strong *ngIf="checkSuitabilityDataObj.activityId == 600104"
                      >&nbsp;({{ univ.educationType }})</strong
                    >
                  </mat-expansion-panel-header>
                  <table mat-table [dataSource]="univ.dnhOutput" aria-describedby="dnhtable" style="margin-top: 1px">
                    <ng-container matColumnDef="radiobutton">
                      <th mat-header-cell *matHeaderCellDef id="radio"></th>
                      <td mat-cell *matCellDef="let element; let index = index">
                        <span>
                          <mat-radio-group aria-label="Select an option" id="sortByUniv-{{ univ.nameAsPerRecord }}">
                            <mat-radio-button
                              [value]="univ.selectedElement"
                              (change)="
                                radiobuttonChange(element, false, univ.nameAsPerRecord, selectedIndexUniv, 'university')
                              "
                              [checked]="univ.selectedElement && univ.selectedElement == element"
                              [disabled]="univ.dnhFlag"
                            >
                            </mat-radio-button>
                          </mat-radio-group>
                        </span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="organization">
                      <th mat-header-cell *matHeaderCellDef id="organization">
                        <span *ngIf="checkSuitabilityDataObj.activityId == 600104">University</span>
                      </th>
                      <td mat-cell *matCellDef="let element; let index = index">
                        {{ element.organization }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="abbreviated">
                      <th mat-header-cell *matHeaderCellDef id="abbreviated">Abbreviated</th>
                      <td mat-cell *matCellDef="let element; let index = index">
                        {{ element.abbreviated }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="category">
                      <th mat-header-cell *matHeaderCellDef id="category">Category</th>
                      <td mat-cell *matCellDef="let element; let index = index">
                        {{ element.category }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="score">
                      <th mat-header-cell *matHeaderCellDef id="score">Match Score</th>
                      <td mat-cell *matCellDef="let element">{{ element.score | number: '1.0-2' }}%</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" style="height: 40px"></tr>
                  </table>
                  <br />
                  <div style="padding-left: 26px" *ngIf="univ && univ.dnhOutput.length > 0" class="d-flex justify-content-between align-items-center">
                    <mat-checkbox
                      [value]="univ.selectedElement"
                      (change)="
                        radiobuttonChange(
                          univ.nameAsPerRecord,
                          true,
                          univ.nameAsPerRecord,
                          selectedIndexUniv,
                          'university',
                          $event
                        )
                      "
                      [checked]="univ.selectedElement && univ.selectedElement == univ.nameAsPerRecord"
                      style="font-size: 15px"
                      [disabled]="univ.dnhFlag"
                      id="radioNonDNHUniv{{ univ.nameAsPerRecord }}{{ univInd }}"
                    >
                      {{ univ.nameAsPerRecord }} is NOT a Suspect/Orange/DNH University
                    </mat-checkbox>
                    <mat-checkbox
                      [checked]="univ.sendToBgv"
                      (change)="toggleSendToBgv(univ, $event)"
                      style="font-size: 15px"
                      [disabled]="univ.nonDNHelement || !univ.selectedElement || univ.dnhFlag"
                      id="sendToBgvUniv{{ univ.nameAsPerRecord }}{{ univInd }}"
                    >
                      Send to BGV for Suspect/Orange/DNH Review
                    </mat-checkbox>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </span>
          </div>

          <div *ngIf="dnhCase">
            <mat-checkbox
              id="DNHcheckboxRAI"
              class="custom-check"
              [disabled]="companyHiringType == 1"
              [checked]="dnhCase"
              (change)="changeRAI()"
            >
              Perform RAI
            </mat-checkbox>
          </div>
          <br />
        </span>

        <span *ngIf="!error && !error1 && checkSuitabilityDataObj.activityId == 600105 && !editactivity">
          <span *ngFor="let univ of univObj; let i = index">
            <mat-accordion class="accordion">
              <mat-expansion-panel
                [expanded]="expandedEvent === univ.nameAsPerRecord && i == selectedIndex"
                (opened)="expandedEvent = univ.nameAsPerRecord; selectedIndex = i"
              >
                <mat-expansion-panel-header class="customExpansionPanel">
                  <strong> {{ univ.nameAsPerRecord }}</strong>
                </mat-expansion-panel-header>
                <table mat-table [dataSource]="univ.dnhOutput" aria-describedby="dnhtable" style="margin-top: 1px">
                  <ng-container matColumnDef="radiobutton">
                    <th mat-header-cell *matHeaderCellDef id="radio"></th>
                    <td mat-cell *matCellDef="let element; let index = index">
                      <span>
                        <mat-radio-group aria-label="Select an option" id="sortByOrg-{{ univ.nameAsPerRecord }}">
                          <mat-radio-button
                            [value]="univ.selectedElement"
                            (change)="radiobuttonChange(element, false, univ.nameAsPerRecord, selectedIndex, 'org')"
                            [checked]="univ.selectedElement && univ.selectedElement == element"
                            [disabled]="univ.dnhFlag"
                          >
                          </mat-radio-button>
                        </mat-radio-group>
                      </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="organization">
                    <th mat-header-cell *matHeaderCellDef id="organization">Organisation</th>
                    <td mat-cell *matCellDef="let element; let index = index">
                      {{ element.organization }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="abbreviated">
                    <th mat-header-cell *matHeaderCellDef id="abbreviated">Abbreviated</th>
                    <td mat-cell *matCellDef="let element; let index = index">
                      {{ element.abbreviated }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="category">
                    <th mat-header-cell *matHeaderCellDef id="category">Category</th>
                    <td mat-cell *matCellDef="let element; let index = index">
                      {{ element.category }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="score">
                    <th mat-header-cell *matHeaderCellDef id="score">Match Score</th>
                    <td mat-cell *matCellDef="let element">{{ element.score | number: '1.0-2' }}%</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns" style="height: 40px"></tr>
                </table>
                <br />
                <div style="padding-left: 26px" *ngIf="univ && univ.dnhOutput.length > 0" class="d-flex justify-content-between align-items-center">
                  <mat-checkbox
                    [value]="univ.selectedElement"
                    (change)="
                      radiobuttonChange(univ.nameAsPerRecord, true, univ.nameAsPerRecord, selectedIndex, 'org', $event)
                    "
                    [checked]="univ.selectedElement && univ.selectedElement == univ.nameAsPerRecord"
                    style="font-size: 15px"
                    [disabled]="univ.dnhFlag"
                    id="radioNonDNHOrg{{ univ.nameAsPerRecord }}{{ i }}"
                  >
                    {{ univ.nameAsPerRecord }} is NOT a Suspect/Orange/DNH Organisation
                  </mat-checkbox>
                  <mat-checkbox
                    [checked]="univ.sendToBgv"
                    (change)="toggleSendToBgv(univ, $event)"
                    style="font-size: 15px"
                    [disabled]="univ.nonDNHelement || !univ.selectedElement || univ.dnhFlag"
                    id="sendToBgvOrg{{ univ.nameAsPerRecord }}{{ i }}"
                  >
                    Send to BGV for Suspect/Orange/DNH Review
                  </mat-checkbox>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </span>
          <div *ngIf="dnhCase">
            <mat-checkbox
              id="DNHcheckboxRAI"
              class="custom-check"
              [disabled]="companyHiringType == 1"
              [checked]="dnhCase"
              (change)="changeRAI()"
            >
              Perform RAI
            </mat-checkbox>
          </div>
          <br />
        </span>

        <form name="suitabilityForm" #f="ngForm">
          <!-- test div to fire validation -->
          <div *ngIf="this.testformValid(!f.invalid)"></div>

          <mat-checkbox *ngIf="fresher" class="custom-check" (change)="changeFresher($event)">
            Candidate is a Fresher
          </mat-checkbox>

          <mat-form-field class="custom-form-field" *ngIf="!hideNotesAndBtn">
            <input
              matInput
              placeholder="Notes"
              name="notes"
              [(ngModel)]="notes"
              [value]="notes"
              (input)="notes = $event.target.value"
            />
          </mat-form-field>
          <div class="col-md-12" *ngIf="hideNotesAndBtn">
            <app-activity-update-offer-detail
              *ngIf="!hideUpdate"
              (childEvent)="eventHandler($event)"
              (hideDiv)="destroyCard($event)"
              [selectedCand]="this.selectedCand"
              [checkSuitabilityDataObj]="checkSuitabilityDataObj"
              [candidateApplicationIds]="candidateApplicationIds"
            ></app-activity-update-offer-detail>
          </div>

          <div *ngIf="this.dnhBoolean == true" class="mt-2 mb-2 ml-1">
            <mat-label *ngFor="let a of this.nh_trueArray">
              <span id="dnhM" class="marginicon40 mainBodyTxt3 GreyLight blockInfo">
                {{ a }}
              </span>
            </mat-label>
          </div>

          <mat-card appearance="outlined" *ngIf="!hideNotesAndBtn">
            <!-- <mat-slide-toggle class="custom-slideToggle" disableRipple="true">Attachment</mat-slide-toggle> -->
            <!-- <app-attachment></app-attachment> -->
            <span
              *ngIf="
                checkSuitabilityDataObj.activityId == 600105 ||
                (checkSuitabilityDataObj.activityId == 600104 && companyHiringType != 1)
              "
            >
              <br />
              <div>For orange cases, Please upload Neutral documents(Supporting documents)</div>
              <div>For suspect cases, Please upload exceptional approval from the Background Verification Team</div>
              <br />
            </span>
            <span *ngIf="checkSuitabilityDataObj.activityId == 600104 && companyHiringType == 1">
              <br />
              <div>
                For orange cases, Please upload Neutral documents(Supporting documents) under Education Negation
                Exception category
              </div>
              <div>
                For suspect cases, Please upload exceptional approval from the Background Verification Team under
                Education Negation Exception category
              </div>
              <br />
            </span>
            <app-attachment
              (fileOutput)="receiveFileOutput($event)"
              (existingFile)="recieveExistingFile($event)"
              [toggleBtn]="toggleBtn"
              [allowedTypes]="allowedTypes"
              [uploadType]="multiple"
              [editId]="editId"
              [isMapFile]="isMapFile"
              activityModuleFlag="true"
            ></app-attachment>
          </mat-card>

          <div class="row" *ngIf="!ifCoupled">
            <div class="col-md-2" *ngIf="!hideNotesAndBtn">
              <div class="row nomarLR padTB16">
                <button
                  mat-raised-button
                  class="primary-btn btnfullWdth"
                  name="suitabilityFormBtn"
                  type="submit"
                  [disabled]="checkForDisabled(f)"
                  (click)="activityAction()"
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions class="collapseAction m-auto">
        <div>
          <a
            href="javascript:void(0)"
            [ngClass]="isCollapsed ? 'icon x-24 up-arw-icon' : 'icon x-24 down-arw-icon'"
            (click)="showMoreLess()"
          ></a>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
<!-- . -->
